export const version = '6.5.0';
export const navbarBreakPoint = 'xl'; // Vertical navbar breakpoint
export const topNavbarBreakpoint = 'lg';
// export const APIBaseURL = 'http://127.0.0.1:8000';
export const APIBaseURL = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port + '/api';
export const settings = {
  isFluid: true,
  isRTL: false,
  isDark: false,
  isTopNav: false,
  isVertical: true,
  get isCombo() {
    return this.isVertical && this.isTopNav;
  },
  showBurgerMenu: false, // controls showing vertical nav on mobile
  currency: '¥',
  isNavbarVerticalCollapsed: false,
  navbarStyle: 'transparent',
  language: 'zh_CN', //default language: en, zh_CN, de, fr, es, ru, ar, vi, th, tr, ms, id, zh_TW, ko_KR, pt, it, pol, nl, jp, fa
  showOnlineMap: false, // indicates if show online map on dashboard
  mapboxToken: 'GET-YOUR-TOKEN-AT-MAPBOX.COM', // you can get access token at https://mapbox.com
  cookieExpireTime: 1000 * 60 * 60, //cookie expires time in milliseconds
  showTCEData: true, // indicates if show Tonne of Coal Equivalent data on dashboard and reports
  enableAIAnalysis: false, // indicates if show AI analysis buttons on reports, also set DEEPSEEK_API_KEY in myems-api/.env
};

const config = { version, navbarBreakPoint, topNavbarBreakpoint, settings, APIBaseURL };
export default config;
